import React from 'react'
import iconCheck from "./img/icon _check_.png";
import closeIcon from "./img/close.png";
import "./styles/ProofImages.scss";

const ProofImages = () => {
  return (
    <div className="step-4-form__container-imgs col-lg-11 mx-auto d-lg-flex">
      <div className="proof-images__project-image bg-secondary col-lg-6 border position-relative">
        <section className='proof-images__bottom-box bg-white rounded position-absolute'>
          <img src={iconCheck} alt='icon-check-image' />
        </section>
      </div>
      <div className="proof-images__project-image-blur bg-secondary col-lg-6 mt-4 mt-lg-0 border">
        <section className='proof-images__bottom-box bg-white rounded position-absolute'>
          <img className='proof-images__close-icon' src={closeIcon} alt='close-icon-image' width={18} />
        </section>
      </div>
    </div>
  );
}

export default ProofImages
